import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useHistory } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import {
  clearCottage,
  fetchCottageRequest,
  updateCottageRequest,
} from 'actions/cottage';
import * as cottageSelectors from 'selectors/cottage';
import Errors from 'components/shared/Errors';
import Success from 'components/shared/Success';
import {
  isStrict as isStrictSelector,
} from 'selectors/user';
import PATHS from 'constants/paths';
import Main from 'components/templates/Main';
import moment from 'logic/moment';

import StripeProviderWrapper from 'components/shared/StripeProviderWrapper';
import PaymentPage from '../components/Payment';

const getError = (error) => {
  if (error && error.status === 400 && error.message === 'User does not own room') {
    return {
      message: (
        <FormattedMessage
          id="error.notAllowedError"
          defaultMessage="You are not allowed to view this page,
            this can happen if you logged in with another e-mail
            address than the one linked to this cottage.
            If that is the case log out and login with the e-mail
            linked to this ad to display this page."
        />
      ),
    };
  }

  return error;
};

const CottagePayment = () => {
  const dispatch = useDispatch();
  const { cottageId } = useParams();
  const history = useHistory();
  const cottage = useSelector(cottageSelectors.data);
  const error = useSelector(cottageSelectors.error);
  const isLoading = useSelector(cottageSelectors.isFetching);
  const isStrict = useSelector(isStrictSelector);
  const success = useSelector(cottageSelectors.updateSuccess);

  React.useEffect(() => {
    if (!isLoading) {
      if (!isStrict) {
        history.replace(`${PATHS.users.profile}?next=${PATHS.cottages.create}`);
      } else if (!cottage || cottage?.id !== parseInt(cottageId, 10)) {
        dispatch(fetchCottageRequest({ cottageId }));
      }
    }
  }, [isStrict]);

  React.useEffect(() => {
    return () => {
      // clear the cottage only if we are moving away to another section
      const within = history.location.pathname.includes(PATHS.cottages.edit.replace(':cottageId', cottageId));

      if (!within) {
        dispatch(clearCottage());
      }
    };
  }, []);

  const submitCommission = () => {
    dispatch(updateCottageRequest({
      cottageId,
      dialog: 'new',
      values: {
        commission: true,
      },
    }));
  };

  const submitCommissionAndAskForReview = () => {
    dispatch(updateCottageRequest({
      cottageId,
      dialog: 'new',
      values: {
        asked_for_review_at: moment().toISOString(),
        commission: true,
      },
    }));
  };

  return (
    <Main
      title={(
        <div>
          <FormattedMessage
            id="payment.paymentForAd"
            defaultMessage="Payment for ad"
          /> #{cottage?.id}
        </div>
      )}
    >
      <StripeProviderWrapper>
        <PaymentPage
          cottage={cottage}
          submitCommission={submitCommission}
          submitCommissionAndAskForReview={submitCommissionAndAskForReview}
        />
      </StripeProviderWrapper>
      <Success success={success} />
      <Errors errors={getError(error)} />
    </Main>
  );
};

export default CottagePayment;
